import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showConfirmation } from '../../../ConfirmationModal';
import TagsBySelection from '../../TagsAndChips/TagsBySelection';
import { showNotification } from '../../../StatusNotification';

export class NewsTableForm extends Component {
    static displayName = NewsTableForm.name;

    constructor(props) {
        super(props);
        this.state = {
            newsTable: null,
            newsConfiguration: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            limitEntries: false,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false,
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newNewsTable = this.state.newsTable;

        if (e.target.name == "isCompact") {
            newNewsTable[e.target.name] = e.target.checked ? true : false;
        }
        else if (e.target.name == "maxEntries") {
            newNewsTable[e.target.name] = parseInt(e.target.value);
        }
        else {
            newNewsTable[e.target.name] = e.target.value;
        }

        this.setState({ newsTable: newNewsTable });
    }

    handleLimitEntriesChange = (e) => {
        let limitEntries = e.target.checked ? true : false;
        if (limitEntries) {
            this.setState({
                limitEntries: limitEntries
            });
        }
        else {
            let newNewsTable = this.state.newsTable;
            newNewsTable['maxEntries'] = 0;

            this.setState({
                limitEntries: limitEntries,
                newsTable: newNewsTable
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let newsTable = this.state.newsTable;
        newsTable.versionId = this.state.versionId;
        newsTable.pageId = this.state.pageId;
        let url = this.state.formType == "Update" ? "UpdateNewsTable" : "CreateNewsTable";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(newsTable),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    if (!this.state.isEditOnly) {
                        var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                        var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "NewsTable", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    }
                    
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let componentName = null;
        let typesField = null;
        let isCompact = false;
        let maxEntries = 0;

        let limitEntries = this.state.limitEntries;

        if (this.state.newsTable != null && this.state.newsConfiguration != null) {
            let newsTable = this.state.newsTable;
            let newsConfiguration = this.state.newsConfiguration;

            componentName = newsTable.componentName;
            isCompact = newsTable.isCompact;
            maxEntries = newsTable.maxEntries;

            let types = newsTable.types != "" && newsTable.types != null ? newsTable.types.split(',') : [];
            let typeSelections = newsConfiguration.types != "" && newsConfiguration.types != null ? newsConfiguration.types.split(',') : [];

            let typesKeyVal = [];
            for (var i = 0; i < types.length; i++) {
                typesKeyVal.push({ key: types[i], value: types[i] });
            }
            let typeSelectionsKeyVal = [];
            for (var i = 0; i < typeSelections.length; i++) {
                typeSelectionsKeyVal.push({ key: typeSelections[i], value: typeSelections[i] });
            }

            let allowDelete = this.state.versionStatus == 'draft' ? true : false;
            typesField = <TagsBySelection
                tags={typesKeyVal}
                tagSelections={typeSelectionsKeyVal}
                name='types'
                isRequired={true}
                allowDuplicates={false}
                allowDelete={allowDelete}
                showInput={true}
                tagUpdate={this.handleChange}
            />;
        }

        let maxEntriesField;
        if (this.state.limitEntries) {
            maxEntriesField = <>
                <label htmlFor='newsTable-maxEntries'>Max Entries: </label>
                <input id='newsTable-maxEntries' name='maxEntries' type='number' defaultValue={maxEntries} onChange={this.handleChange} min={1} step={1} />
            </>;
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <form onSubmit={this.handleSubmit} className={wrapperClasses}>
                <div className='dual-grid'>
                    <div className='dual-grid__1-2 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('NewsTable')}</h2>
                    </div>

                    <label htmlFor='newsTable-componentName'>Component Name:</label>
                    <input id='newsTable-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />

                    <label>Types: </label>
                    {typesField}

                    <label>Compact View: </label>
                    <div className='checkbox-wrapper'>
                        <input name='isCompact' type='checkbox' checked={isCompact} onChange={this.handleChange} />
                    </div>

                    <label>Limit Entries: </label>
                    <div className='checkbox-wrapper'>
                        <input name='limitEntries' type='checkbox' checked={limitEntries} onChange={this.handleLimitEntriesChange} />
                    </div>

                    {maxEntriesField}

                    <div className='dual-grid__1-2'>
                        <button type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetNewsTable?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        let limitEntries = data.newsTable.maxEntries > 0 ? true : false;

        this.setState({
            newsTable: data.newsTable,
            newsConfiguration: data.newsConfiguration,
            formType: formType,
            limitEntries: limitEntries
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteNewsTable?componentId=' + this.state.newsTable.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default NewsTableForm;
